import { render, staticRenderFns } from "./UserFirstAndLastName.vue?vue&type=template&id=53540060"
import script from "./UserFirstAndLastName.vue?vue&type=script&lang=js"
export * from "./UserFirstAndLastName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports